import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["pageParam"],
  _excluded2 = ["pageParam"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { QueryObserver } from './queryObserver.mjs';
import { infiniteQueryBehavior, hasNextPage, hasPreviousPage } from './infiniteQueryBehavior.mjs';
var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  _inherits(InfiniteQueryObserver, _QueryObserver);
  var _super = _createSuper(InfiniteQueryObserver);
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    _classCallCheck(this, InfiniteQueryObserver);
    return _super.call(this, client, options);
  }
  _createClass(InfiniteQueryObserver, [{
    key: "bindMethods",
    value: function bindMethods() {
      _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "bindMethods", this).call(this);
      this.fetchNextPage = this.fetchNextPage.bind(this);
      this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options, notifyOptions) {
      _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "setOptions", this).call(this, _objectSpread(_objectSpread({}, options), {}, {
        behavior: infiniteQueryBehavior()
      }), notifyOptions);
    }
  }, {
    key: "getOptimisticResult",
    value: function getOptimisticResult(options) {
      options.behavior = infiniteQueryBehavior();
      return _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "getOptimisticResult", this).call(this, options);
    }
  }, {
    key: "fetchNextPage",
    value: function fetchNextPage() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        pageParam = _ref.pageParam,
        options = _objectWithoutProperties(_ref, _excluded);
      return this.fetch(_objectSpread(_objectSpread({}, options), {}, {
        meta: {
          fetchMore: {
            direction: 'forward',
            pageParam: pageParam
          }
        }
      }));
    }
  }, {
    key: "fetchPreviousPage",
    value: function fetchPreviousPage() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        pageParam = _ref2.pageParam,
        options = _objectWithoutProperties(_ref2, _excluded2);
      return this.fetch(_objectSpread(_objectSpread({}, options), {}, {
        meta: {
          fetchMore: {
            direction: 'backward',
            pageParam: pageParam
          }
        }
      }));
    }
  }, {
    key: "createResult",
    value: function createResult(query, options) {
      var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;
      var state = query.state;
      var result = _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "createResult", this).call(this, query, options);
      var isFetching = result.isFetching,
        isRefetching = result.isRefetching;
      var isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward';
      var isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward';
      return _objectSpread(_objectSpread({}, result), {}, {
        fetchNextPage: this.fetchNextPage,
        fetchPreviousPage: this.fetchPreviousPage,
        hasNextPage: hasNextPage(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
        hasPreviousPage: hasPreviousPage(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
        isFetchingNextPage: isFetchingNextPage,
        isFetchingPreviousPage: isFetchingPreviousPage,
        isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
      });
    }
  }]);
  return InfiniteQueryObserver;
}(QueryObserver);
export { InfiniteQueryObserver };